<div class="strategy-wizard">
  <!-- Wizard Content -->
  <ng-container>
    <!-- Progress Steps -->
    <div class="wizard-header">
      <p-steps 
        [model]="steps" 
        [activeIndex]="currentStep - 1" 
        [readonly]="false"
        (activeIndexChange)="onStepClick($event)"
      ></p-steps>
    </div>
    
    <!-- Wizard Content (Solo 2 pasos) -->
    <div class="wizard-content">
      <app-step1-basic *ngIf="currentStep === 1"></app-step1-basic>
      <app-step2-channels *ngIf="currentStep === 2"></app-step2-channels>
    </div>
  
  <!-- Navigation Buttons -->
  <div class="wizard-navigation">
    <div class="left-actions">
      <button 
        pButton 
        type="button"
        label="Cancelar" 
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="cancel()"
      ></button>
    </div>
    
    <div class="right-actions">
      <button 
        pButton 
        type="button"
        label="Anterior" 
        icon="pi pi-chevron-left"
        class="p-button-outlined"
        [disabled]="currentStep === 1"
        (click)="previous()"
        *ngIf="currentStep > 1"
      ></button>
      
      <button 
        pButton 
        type="button"
        [label]="isLastStep ? 'Guardar Estrategia' : 'Siguiente'" 
        [icon]="isLastStep ? 'pi pi-check' : 'pi pi-chevron-right'"
        iconPos="right"
        [disabled]="!canGoNext"
        (click)="isLastStep ? save() : next()"
      ></button>
    </div>
  </div>
  </ng-container>
</div>

<!-- Toast Messages -->
<p-toast position="top-right"></p-toast>
